import React from 'react';
import './index.less';

class IndexPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        // 组件是否挂载了
        this.mounted = false;
    }
    // 组件卸载回调
    componentWillUnmount() {
        // 标记组件未挂载
        this.mounted = false;
    }
    // 组件加载回调
    componentDidMount() {
        // 标记组件挂载了
        this.mounted = true;
    }
    render() {
        return (
            <div className='site-business-page'>
                <p>合作联系人：黄先生</p>
                <p>联系QQ：1429028458</p>
                <p>合作邮箱：yiquwangluo@qq.com</p>
                <p>联系电话：15626100247</p>
            </div>
        )
    }
}

export default IndexPage;